module.exports = __webpack_public_path__ + "img/fail1.57da04cf.svg";